<!-- src/components/common/BackButton.vue -->
<template>
  <button
    type="button"
    class="back-btn"
    :disabled="disabled"
    @click="handleBackClick"
    :aria-disabled="disabled ? 'true' : 'false'"
  >
    <slot>← Back</slot>
  </button>
</template>

<script>
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'BackButton',
  props: {
    fallback: {
      type: [String, Object],
      default: '/host'
    },
    forcePush: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    openInNewTab: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const router = useRouter()

    function hasHistory() {
      if (typeof window === 'undefined') return false
      return window.history.length > 1
    }

    function getPreviousUrl() {
      if (typeof window === 'undefined') return null
      const referrer = document.referrer
      if (referrer && referrer !== window.location.href) {
        return referrer
      }
      return null
    }

    async function handleBackClick() {
      if (props.disabled) return
      
      if (props.openInNewTab) {
        const previousUrl = getPreviousUrl()
        if (previousUrl) {
          window.open(previousUrl, '_blank')
        } else {
          const fallbackUrl = typeof props.fallback === 'string' 
            ? props.fallback 
            : router.resolve(props.fallback).href
          window.open(fallbackUrl, '_blank')
        }
        return
      }
      
      if (props.forcePush) {
        await router.push(props.fallback)
        return
      }
      
      try {
        if (hasHistory()) {
          router.back()
        } else {
          await router.push(props.fallback)
        }
      } catch (error) {
        await router.push(props.fallback)
      }
    }

    return { handleBackClick }
  }
})
</script>

<style scoped>
.back-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  cursor: pointer;
  min-height: 36px;
}
.back-btn:focus-visible {
  outline: 2px solid #0d6efd;
  outline-offset: 2px;
  border-radius: 6px;
}
.back-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
